import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      width: "100%",
      height: "1000px",
      padding: "32px",
      marginTop: 64,
      marginBottom: 50,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
      width: "100%",
    },
    controlsContainer: {
      backgroundColor: "#FFFFFF",
      marginBottom: "16px",
    },
    titleGroup: {
      display: "flex",
      alignItems: "center",
      marginBottom: "16px",
    },
    newsTypo: {
      fontSize: "22px",
      fontWeight: "bold",
      color: "#393921",
    },
    newsButton: {
      minWidth: "150px",
      textTransform: "none",
    },
    newsListContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      height: "800px",
      backgroundColor: "#FFFFFF",
      width: "100%",
    },
    list: {
      padding: 0,
    },
    card: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
      // padding: "5px 10px",
    },
    textBase: {
      flex: 1,
    },
    buttonBase: {},
    header: {
      display: "flex",
      width: "100%",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      backgroundColor: "#F2F2F2",
      padding: "5px 10px",
    },
    headerText: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
    },
    dateTypo: {
      fontSize: "12px",
      color: "#393921",
    },
    captionTypo: {
      fontSize: "18px",
      fontWeight: "bold",
      color: "#61614d",
    },
    descriptionTypo: {
      fontSize: "16px",
      color: "#393921",
      padding: "5px 10px",
      width: "100%",
    },
    paginationRoot: {
      height: "60px",
    },
  });
